import { render, staticRenderFns } from "./Bottwitter.vue?vue&type=template&id=360c4b9a&scoped=true"
import script from "./Bottwitter.vue?vue&type=script&lang=js"
export * from "./Bottwitter.vue?vue&type=script&lang=js"
import style0 from "./Bottwitter.vue?vue&type=style&index=0&id=360c4b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c4b9a",
  null
  
)

export default component.exports